export const OPEN_OVERLAYER = 'OPEN_OVERLAYER';
export const openOverlayer = (name) => ({ type: OPEN_OVERLAYER, name });

export const CLOSE_OVERLAYER = 'CLOSE_OVERLAYER';
export const closeOverlayer = (name) => ({ type: CLOSE_OVERLAYER, name });
